import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    me: {
      medium: 'https://medium.com/@t3chflicks',
      gitlab: 'https://gitlab.com/skelly123',
      linkedIn: 'https://www.linkedin.com/in/sebastian-kelly---------',
    },
    projects: [
      {
        link: 'https://t3chflicks.xyz',
        title: 'T3chFlicks',
        publishedTime: new Date('2020, 12, 12').getTime(),
        description: 'An tech focused edutainment platform. We build things such as the Smart Buoy.',
      },
      {
        link: 'https://google.com',
        title: 'Home Development Pipeline',
        publishedTime: new Date('2020, 12, 12').getTime(),
        description: 'A raspberry Pi based home development environment, using industry best practices for development. Includes Gitea repository, Drone CI,  Docker registry, Traefik',
      },
      {
        link: 'https://medium.com/@sebastian.kelly123/speedy-bpm-counter-in-osx-dashboard-23f64e40882d',
        title: 'Easy OSX Widgets',
        publishedTime: new Date('2020, 12, 12').getTime(),
        description: 'In this article I show you how I made a BPM Counter in a simple HTML page coupled with vanilla javascript (see here). If downloaded, this widget can be used offline - ideal for musicians who want to create but do not always have internet access. Even better, by using the OSX dashboard app (which never seemed that useful before), we can make this BPM Counter extra quick to use.',
      },
      {
        link: 'https://gitlab.com/skelly123/proth_primality_testing',
        title: 'Proth Prime',
        publishedTime: new Date('2020, 12, 12').getTime(),
        description: 'Final year Physics Project. Test numbers of type N=k*2^n +1, where k is odd and k<2^n, for primality using a^{(N-1)/2} = -1 (mod N).',
      },
    ],
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
  getters: {
    latest: state => [...state.projects.sort((a, b) => a.publishedTime < b.publishedTime)].splice(0, 3),
    all: state => [...state.projects.sort((a, b) => a.publishedTime < b.publishedTime)],
  },
});
